export default __webpack_public_path__ + "static/soda2-5da97d478ab46c2fa5d92d8c027bb6ba.png";